__turbopack_context__.v({
  "container": "LookFeedback-module-scss-module__r41Kta__container",
  "imageContainer": "LookFeedback-module-scss-module__r41Kta__imageContainer",
});
